import {useIdleTimer} from 'react-idle-timer';
import {VIDEO_PATH} from '@/config';

/**
 * Session idle detection (extracted from Root to isolate timer subscriptions).
 */
const RootIdleTimers = ({
    pathname,
    setShowIdleModal,
    setTriggerUnreadCounter,
}) => {
    const onIdle = () => {
        if (pathname?.includes(VIDEO_PATH)) return;

        if (
            (window?.process?.env?.ENVIRONMENT ?? process.env.ENVIRONMENT) !==
            'local'
        ) {
            setShowIdleModal(true);
        }
    };

    const onIdleWTOMessageCounter = () => {
        if (pathname?.includes(VIDEO_PATH)) return;

        if (
            (window?.process?.env?.ENVIRONMENT ?? process.env.ENVIRONMENT) !==
            'local'
        ) {
            setTriggerUnreadCounter(true);
        }
    };

    useIdleTimer({
        element: document,
        debounce: 1000,
        timeout: 840000, // 14 minutes
        onIdle,
    });

    useIdleTimer({
        element: document,
        debounce: 1000,
        timeout: 540000, // 9 minutes
        onIdle: onIdleWTOMessageCounter,
    });

    return null;
};

export default RootIdleTimers;
